import React from 'react'; //, { Component }
import {Link} from 'react-router-dom';
import MoldLogo from '../../svg/mold-logo.js';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        menuOpen: false,
        headerNormal: false
      }

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  }

  closeMenu = () => {
    this.setState({menuOpen: false});
  }

  render() {
    return (
      <header className={`site-header ${this.state.headerNormal ? 'normal' : ''}`}>
        <div  id="nav-cnt"
              className={'nav-cnt' + (this.state.menuOpen ? ' active': '')}
        >
          <nav id="main-nav" className="main-nav">
            <div className="nav-item home-btn"><Link to="/" onClick={this.closeMenu}><MoldLogo /></Link></div>
            <div className="nav-item info-btn"><Link to="/info" onClick={this.closeMenu}>Info</Link></div>
            <div className="nav-item news-btn"><Link to="/news" onClick={this.closeMenu}>News</Link></div>
            <div className="nav-item work-btn"><Link to="/" onClick={this.closeMenu}>Projects</Link></div>
          </nav>
          <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
          <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
          <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
          <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
        </div>
        <Link to="/" className="mobile-logo"><MoldLogo /></Link>
        <button className={`hamburger hamburger--squeeze menu-btn ${this.state.menuOpen ? 'is-active' : ''}`} type="button" onClick={this.toggleMenu}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/scripts/components/header.js